import { render, staticRenderFns } from "./salesAccount.vue?vue&type=template&id=e064c0c8&scoped=true&"
import script from "./salesAccount.vue?vue&type=script&lang=js&"
export * from "./salesAccount.vue?vue&type=script&lang=js&"
import style0 from "./salesAccount.vue?vue&type=style&index=0&id=e064c0c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e064c0c8",
  null
  
)

export default component.exports